import { LitElement, html, css } from 'lit';


class RichOverlay extends LitElement {

  static get properties() {
    return {
      open: {
        type: Boolean,
        reflect: true
      },
      closeOnEscape: { type: Boolean },
    };
  }

  static get styles() {
    return [
      css`
        :host {
          --_overlay-width: var(--rich-overlay-width, 100%);
          --_overlay-width-neg: calc(var(--_overlay-width) * -1);

          --_overlay-height: var(--rich-overlay-height, 100%);
          --_overlay-height-neg: calc(var(--_overlay-height) * -1);

          box-sizing: border-box;
          position: fixed;
          overflow: hidden;

          width: var(--_overlay-width);
          height: var(--_overlay-height);

          background-color: var(--rich-overlay-bg, rgba(0, 0, 0, 0.9));
        }

        :host([from-top]) {
          top: 0;
          left: 0;
          transform: translateY(var(--_overlay-height-neg));
        }

        :host([from-bottom]) {
          bottom: 0;
          left: 0;
          transform: translateY(var(--_overlay-height));
        }

        :host([from-left]) {
          left: 0;
          top: 0;
          transform: translateX(var(--_overlay-width-neg));
        }

        :host([from-right]) {
          top: 0;
          right: 0;
          transform: translateX(var(--_overlay-width));
        }

        :host([local]) { position: absolute; }

        :host([open]) {
          transform: translate(0, 0);
        }

        .content {
          box-sizing: border-box;
          padding: var(--rich-overlay-content-padding, 10px);
          width: 100%;
          height: 100%;
        }
      `
    ];
  }

  render() {
    return html`
      <div class="content">
        <slot name="content"></slot>
      </div>
    `;
  }

  constructor() {
    super();
    this.closeOnEscape = true;
    this.open = false;
  }

  connectedCallback() {
    super.connectedCallback();
  }

  firstUpdated() {
    super.firstUpdated();

    document.addEventListener('keyup', (ev) => {
      if (ev.which == 27) {
        if (this.open) { this.hide(); }
      }
    });

    this.addEventListener('click', (ev) => {
      let contentEl = this.querySelector('[slot="content"]');
      if ((ev.target == this) || (ev.target == contentEl) && this.open) { this.hide(); }
    });

    // Only add transition css after the element was loaded.
    // This avoids a animation when the page is first loaded where
    // the user will briefly see the overlays move out of view as they are
    // first hidden
    window.setTimeout(() => {
      this.style.transition = 'all 0.3s ease';
    }, 0);
  }

  show() {
    this.open = true;
    this.focus();
  }

  hide() {
    this.open = false;
    this.blur();
  }

  toggle() {
    if (this.open) this.hide();
    else this.show();
  }

}

if (typeof customElements.get('rich-overlay') === 'undefined') {
  customElements.define('rich-overlay', RichOverlay);
}
